import { render, staticRenderFns } from "./TrendsOil.vue?vue&type=template&id=e027a076&scoped=true&"
import script from "./TrendsOil.vue?vue&type=script&lang=js&"
export * from "./TrendsOil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e027a076",
  null
  
)

export default component.exports